import React, { useState,useEffect } from 'react'
import categorys from "../../assets/icons/unitsIcons/unitCategory.png"
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation"
import unitsIcon from "../../assets/icons/unitsIcons/units.png"
import toast from 'react-hot-toast';
import {
  deleteDataToken,
  getData,
  patchDataToken,
  postData,
  putDataToken,
} from "../../axios/axiosHelper";
const UnitCategoryType = () => {
 
    const [loading, setLoading] = useState(false);
    const [imageForEdit, setImageForEdit] = useState(false)

    const [unitCategory, setUnitCategory] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  const [deleteCategoryLoading, setDeleteCategoryLoading] = useState({});
  const [oneCategory, setOneCategory] = useState({});
  const [showEditCategory, setShowEditCategory] = useState(false);
  const handleCloseEditCategory = () => setShowEditCategory(false);
  const handleShowEditCategory = () => setShowEditCategory(true);
  const [categoryNameEnEdit, setCategoryNameEnEdit] = useState(null);
  const [categoryNameArEdit, setCategoryNameArEdit] = useState(null);
  const [categoryEn, setCategoryEn] = useState(null);
  const [categoryAr, setCategoryAr] = useState(null);

  const [loadingAddCategory, setLoadingAddCategory] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);  
    const [search, setSearch] = useState("")
    const [image, setImage] = useState(null);
  
    const handleImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        setImage(file);
      }
    };
    const NavItems = [
      { name: ADMIN_PAGE_LABELS.merchantCategories, to: "/category", icon: categorys },
    ];
    const getUnitCategory = (page = 1, perPage = 3, search) => {
      setLoading(true);
      getData(
        `/category?page=${page}&perPage=${perPage}&search=${search}`,
        true
      )
        .then((response) => {
          setUnitCategory(response?.data?.data);
          setTotalPages(response?.data?.pagination?.totalPages || 1);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    };
  
    useEffect(() => {
      getUnitCategory(currentPage, itemsPerPage, search);
    }, [currentPage, itemsPerPage, search]);
    const getPageNumbers = () => {
      const pages = [];
      const startPage = Math.max(1, currentPage - 1);
      const endPage = Math.min(totalPages, startPage + 2);
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    };
  
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    const deleteCategory = async (id) => {
      setDeleteCategoryLoading((prevState) => ({ ...prevState, [id]: true }));
      deleteDataToken(`/category/${id}`)
        .then((response) => {
          toast.success(response?.data?.message);
          getUnitCategory(currentPage, itemsPerPage, search);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setDeleteCategoryLoading((prevState) => ({
            ...prevState,
            [id]: false,
          }));
        });
    };
    const handleclickEditCategory = async (data) => {
      setOneCategory(data);
      setCategoryNameEnEdit(data.nameEn);
      setCategoryNameArEdit(data.nameAr);
      handleShowEditCategory();
    setImageForEdit(data?.image)

    };
    const [categoryEditLoading, setCategoryEditLoading] = useState(false);

    const onSubmitEditCategory = async (e) => {
      e.preventDefault();
      setCategoryEditLoading(true);
      const formData = new FormData();
      formData.append("nameEn", categoryNameEnEdit);
      formData.append("nameAr", categoryNameArEdit);
  
      formData.append("image", image);
      putDataToken(
        `/category/${oneCategory._id}`,
        formData,
        true
      )
        .then((response) => {
          toast.success(response?.data?.message);
          handleCloseEditCategory();
          getUnitCategory(currentPage, itemsPerPage, search);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setCategoryEditLoading(false);
        });
    };

    const handleAddNewCategory = (e) => {
      e.preventDefault();
      setLoadingAddCategory(true);
      const formData = new FormData();
      formData.append("nameEn", categoryEn);
      formData.append("nameAr", categoryAr);
  
      formData.append("image", image);
      postData(
        "/category",
        formData,
        true
      )
        .then((response) => {
          handleClose();
          setCategoryAr(null);
          setCategoryEn(null);
          handleClose();
          getUnitCategory(currentPage, itemsPerPage, search);
          toast.success(response?.data?.message);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setLoadingAddCategory(false);
        });
    };
    return {
      NavItems,
      setSearch,
      handleShow,
      show,
      handleClose,
      unitCategory,
      loading,
      handlePageChange,
      currentPage,
      totalPages,
      getPageNumbers,
      deleteCategoryLoading,
      deleteCategory,
      onSubmitEditCategory,
      handleclickEditCategory,
      showEditCategory,
      handleCloseEditCategory,
      setCategoryNameEnEdit,
      categoryNameEnEdit,
      setCategoryNameArEdit,
      categoryNameArEdit,
      categoryEditLoading,
      setCategoryEn,
      setCategoryAr,
      handleAddNewCategory,
      loadingAddCategory, 
      handleImageChange,
      imageForEdit
    }
}

export default UnitCategoryType
